export default __webpack_public_path__ + "static/media/clipboard.1d22abfc.png";